import { map, Observable } from 'rxjs';

export const invertBool = () => (source$: Observable<boolean>) => source$.pipe(map((value) => !value));
export const invertBool$ = (bool$: Observable<boolean>) => bool$.pipe(invertBool());
